import React, { useState, useEffect } from "react";


function Header() {
  const [stickyMenu, setStickyMenu] = useState(false);
  const [navigationOpen, setNavigationOpen] = useState(false);

  // all dropdowns open/close states
  const [openMenus, setOpenMenus] = useState({
    services: false,
    tofu: false,
    mofu: false,
    bofu: false,
    resources: false,
  });

  // sticky header effect
  useEffect(() => {
    const handleScroll = () => setStickyMenu(window.pageYOffset > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // close mobile menu when resized to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setNavigationOpen(false);
        setOpenMenus({
          services: false,
          tofu: false,
          mofu: false,
          bofu: false,
          resources: false,
        });
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenuKey = (key) => {
    if (window.innerWidth <= 768) {
      setOpenMenus((prev) => ({ ...prev, [key]: !prev[key] }));
    }
  };

  return (
    <div>

   
    <header className={`header ${stickyMenu ? "sticky" : ""}`}>
      <div className="header-inner">
        <a href="/" className="logo">
          <video
        className="hero-video cssimglogo"
        src="/images/logo11.mp4"
        autoPlay
        muted
        loop
        loading="lazy"
        playsInline
      />

          {/* <img src="images/Logo1.png" alt="Logo" /> */}
        </a>

        <button
          className={`hamburger ${navigationOpen ? "active" : ""}`}
          onClick={() => setNavigationOpen(!navigationOpen)}
          aria-label="Toggle navigation"
        >
          ☰
        </button>

        <nav>
          <ul className={`menu ${navigationOpen ? "open" : ""}`}>
            <li><a href="/">HOME</a></li>
            <li><a href="about">ABOUT</a></li>
{/* SERVICES */}
            <li
              className={`has-dropdown ${openMenus.services ? "open" : ""}`}
              onMouseEnter={() =>
                window.innerWidth > 768 &&
                setOpenMenus((p) => ({ ...p, services: true }))
              }
              onMouseLeave={() =>
                window.innerWidth > 768 &&
                setOpenMenus((p) => ({ ...p, services: false }))
              }
            >
              <a
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  toggleMenuKey("services");
                }}
              >
                SERVICES ▾
              </a>

              <ul className="dropdown">
                    <li><a href="Tofuemail">EMAIL MARKETING</a></li>
                    <li><a href="Tofuinent">INTENT DATA SERVICES</a></li>
                    <li><a href="Contentsyndi">CONTENT SYNDICATION</a></li>
                    <li><a href="Displaymarketing">DISPLAY MARKETING</a></li>
                  
                    <li><a href="Moumarketingqul">MARKETING QUALIFIED LEAD</a></li>
                    <li><a href="Mouhql">HIGHLY QUALIFIED LEAD</a></li>
                    <li><a href="Moubant">BUDGET, AUTHORITY, NEED, TIME</a></li>
                    <li><a href="Mouwebinar">WEBINAR</a></li>
                    <li><a href="Bofuappoin">APPOINTMENT GENERATION</a></li>
                    <li><a href="Bofusql">SALES QUALIFIED LEADS</a></li>
              </ul>
            </li>

            <li><a href="careers">CAREERS</a></li>

            {/* RESOURCES */}
            <li
              className={`has-dropdown ${openMenus.resources ? "open" : ""}`}
              onMouseEnter={() =>
                window.innerWidth > 768 &&
                setOpenMenus((p) => ({ ...p, resources: true }))
              }
              onMouseLeave={() =>
                window.innerWidth > 768 &&
                setOpenMenus((p) => ({ ...p, resources: false }))
              }
            >
              <a
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  toggleMenuKey("resources");
                }}
              >
                RESOURCES ▾
              </a>
              <ul className="dropdown">
                <li><a href="Blogs">BLOG</a></li>
                <li><a href="whitepapers">WHITEPAPER</a></li>
              </ul>
            </li>

            <li><a href="Contact">CONTACT</a></li>
          </ul>
        </nav>
      
      </div>
    </header>
   
 </div>
  );
}

export default Header;
